import styled from "styled-components";


export const Layout = styled.div`
  color: #75200b;
  //width: 230px;
  height: 176px;
  //margin-right: 10px;
  padding-top: 0;
  //margin-bottom: 10px;
  background: #fff6f6;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
`;

export const Title = styled.h2`
    em {
      color: #e20f10;
      font-weight: 700;
      font-style: normal;
    }
`;

export const Description = styled.h3`
  color: #75200b;
  display: block;
  font-weight: 700;
  font-size: 16px;
  padding-top: 15px;
  padding-top: 15px;
`;
export const Button = styled.button`
  background: url(//img.smxj.webgame.niuximg.com/acts/sxdvip/img/btn_get.png) no-repeat;
  color: #fef742;
  display: block;
  width: 162px;
  height: 58px;
  line-height: 50px;
  font-size: 18px;
  font-weight: 700;
  margin: 12px auto 0;
  border: none;
  cursor: pointer;
`;